import React from 'react';
import '../../styles/DeleteConfirmModal.css'; // reuse same base styles

export default function ClearAllModal({ patients, onCancel, onConfirm }) {
  const doneCount    = patients.filter(p => p.status === 'done').length;
  const pendingCount = patients.filter(p => p.status === 'pending').length;

  return (
    <div className="dcm__overlay">
      <div className="dcm__modal-container" style={{ maxWidth: 560 }}>

        <div className="dcm__bg" />
        <div className="dcm__bg-tint" />

        <div className="dcm__content">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h6 className="fw-bold mb-0 dcm__title">Clear All Confirmation</h6>
            <button className="dcm__close-btn" onClick={onCancel}>X</button>
          </div>

          <p className="dcm__message text-center mb-3">
            Are you sure you want to clear all patients?
          </p>

          {/* Summary of what will happen */}
          <div style={{
            background: 'rgba(255,255,255,0.75)',
            borderRadius: 10,
            padding: '1rem 1.25rem',
            marginBottom: '1.25rem',
            fontSize: '0.88rem',
          }}>
            {doneCount > 0 && (
              <div className="d-flex align-items-start gap-2 mb-2">
                <i className="fa-solid fa-triangle-exclamation mt-1" style={{ color: '#c0392b', flexShrink: 0 }} />
                <span>
                  <strong>{doneCount} analysed patient{doneCount > 1 ? 's' : ''}</strong> — their analysis records, images and PDF reports will be <strong>permanently deleted</strong>.
                </span>
              </div>
            )}
            {pendingCount > 0 && (
              <div className="d-flex align-items-start gap-2">
                <i className="fa-solid fa-info-circle mt-1" style={{ color: '#1a56db', flexShrink: 0 }} />
                <span>
                  <strong>{pendingCount} pending patient{pendingCount > 1 ? 's' : ''}</strong> — not yet analysed, so no DB or data exists. They will just be removed from the queue.
                </span>
              </div>
            )}
          </div>


          <div className="d-flex justify-content-center gap-3">
            <button className="btn dcm__btn-cancel px-4" onClick={onCancel}>Cancel</button>
            <button
              className="btn dcm__btn-delete px-4"
              onClick={onConfirm}
              style={{ background: '#e02424' }}
            >
              <i className="fa-solid fa-trash me-1" />Clear All
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}